import { render } from "./Score.vue?vue&type=template&id=18db8809&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"

import "./Score.vue?vue&type=style&index=0&id=18db8809&scoped=true&lang=css"
import "./Score.vue?vue&type=style&index=1&id=18db8809&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18db8809"]])

export default __exports__